const review_document = {
	name: 'Belegprüfung | Belegprüfungen',
	fields: {
		hp_id: 'ID',
		name: 'Bezeichnung',
		team: {
			last_name: 'Ansprechpartner',
		},
		status: 'Status',
		active: 'Aktiv',
		completed: 'Abgeschlossen',
		building_id: 'ID Liegenschaft',
		building_name: '@:entity.building.name',
		accounting_year: {
			year: '@:component.accounts.accountingYear',
		},
	},
}

export default review_document
